(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homedics-renueva"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('homedics-renueva')) return;
  customElements.define('homedics-renueva', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      this.cfg = JSON.parse(this.querySelector('[data-hr-config]').textContent);
      this.grid = this.querySelector('[data-hr-grid]');
      this.visibleCount = Number(this.dataset.pageSize) || 12;
      this.pageSize = this.visibleCount;
      this.addEventListener('submit', event => this.submit(event), {signal: this.controller.signal});
      this.addEventListener('change', event => this.variant(event), {signal: this.controller.signal});
      this.addEventListener('click', event => this.click(event), {signal: this.controller.signal});
      this.updateClock();
      this.timer = setInterval(() => this.updateClock(), 1000);
      this.querySelectorAll('[data-hr-copy]').forEach(button => button.hidden = false);
      this.setupMotion();
      this.prepareCatalog();
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
      this.revealObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.initialized = false;
    }
    setupMotion() {
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.motionPaused = false;
      const refresh = () => this.setMotionState();
      this.motionQuery.addEventListener('change', refresh, {signal:this.controller.signal});
      this.querySelector('[data-hr-motion-toggle]')?.addEventListener('click', () => {
        this.motionPaused = !this.motionPaused;
        this.setMotionState();
      }, {signal:this.controller.signal});
      if ('IntersectionObserver' in window) {
        this.revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('hr-in-view');
            this.revealObserver.unobserve(entry.target);
          }
        }), {threshold:0.08,rootMargin:'0px 0px -18px 0px'});
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.dataset.inView = String(entries[0].isIntersecting);
        }, {threshold:0});
        this.visibilityObserver.observe(this);
      }
      this.setMotionState();
      this.observeReveals();
    }
    setMotionState() {
      const allowed = this.dataset.motionEnabled === 'true' && !this.motionQuery.matches && !navigator.connection?.saveData;
      this.dataset.motion = String(allowed && !this.motionPaused);
      const button = this.querySelector('[data-hr-motion-toggle]');
      if (button) {
        button.hidden = !allowed;
        button.setAttribute('aria-pressed',String(this.motionPaused));
        button.textContent = this.motionPaused ? this.cfg.resumeMotion : this.cfg.pauseMotion;
      }
      if (this.dataset.motion !== 'true') this.querySelectorAll('.hr-reveal').forEach(el => el.classList.add('hr-in-view'));
    }
    observeReveals() {
      if (!this.revealObserver || this.dataset.motion !== 'true') return;
      const nodes = this.querySelectorAll('.hr-hero-copy > *, .hr-benefit, .hr-section-head, [data-hr-card], .hr-editorial, .hr-pay-card, .hr-faq, .hr-closing');
      nodes.forEach((el,index) => {
        if (el.classList.contains('hr-reveal')) return;
        el.style.setProperty('--hr-reveal-delay',`${Math.min(index % 4,3) * 65}ms`);
        el.classList.add('hr-reveal');
        this.revealObserver.observe(el);
      });
    }
    updateClock() {
      const now = Date.now(), start = Date.parse(this.dataset.start), end = Date.parse(this.dataset.end);
      const valid = Number.isFinite(start) && Number.isFinite(end) && end > start;
      const state = !valid ? 'invalid' : now < start ? 'before' : now > end ? 'after' : 'active';
      this.dataset.state = state;
      this.querySelectorAll('[data-hr-promo]').forEach(el => el.hidden = state === 'after' || state === 'invalid');
      const label = this.querySelector('[data-hr-clock-label]');
      if (label) label.textContent = this.cfg[state === 'before' ? 'starts' : state === 'active' ? 'ends' : state === 'after' ? 'ended' : 'invalidDate'];
      const clock = this.querySelector('[data-hr-clock]');
      if (clock) {
        clock.hidden = !valid || state === 'after';
        const seconds = Math.max(0, Math.floor(((state === 'before' ? start : end) - now) / 1000));
        const parts = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        clock.querySelectorAll('b').forEach((el, i) => el.textContent = String(parts[i]).padStart(2, '0'));
      }
      this.querySelectorAll('[data-hr-coupon-panel]').forEach(panel => {
        const a = Date.parse(panel.dataset.start), b = Date.parse(panel.dataset.end);
        const datesValid = Number.isFinite(a) && Number.isFinite(b) && b > a;
        panel.hidden = !datesValid || now > b;
        const btn = panel.querySelector('[data-hr-copy]');
        if (btn) btn.disabled = !datesValid || now < a || now > b;
      });
    }
    sortedCards() {
      return [...this.grid.querySelectorAll('[data-hr-card]')].sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price) || a.dataset.title.localeCompare(b.dataset.title));
    }
    displayCards() {
      if (!this.grid) return;
      const cards = this.sortedCards(), active = document.activeElement;
      const fragment = document.createDocumentFragment();
      cards.forEach((card, i) => {card.hidden = i >= this.visibleCount; fragment.appendChild(card);});
      this.grid.appendChild(fragment);
      this.observeReveals();
      if (active && this.contains(active)) active.focus({preventScroll:true});
      const more = this.querySelector('[data-hr-more]');
      if (more) more.hidden = cards.length <= this.visibleCount;
      const empty = this.querySelector('[data-hr-empty]');
      if (empty) empty.hidden = cards.length > 0;
    }
    async prepareCatalog() {
      if (!this.grid) return;
      const nav = this.querySelector('[data-hr-pages]');
      if (nav) nav.classList.add('hr-pagination-enhanced');
      this.nextPage = this.querySelector('[data-hr-next]')?.href || '';
      const first = this.querySelector('[data-hr-first]');
      if (first) {this.nextPage = first.href;this.grid.replaceChildren();}
      this.displayCards();
      if (this.nextPage) await this.loadCatalog();
    }
    async loadCatalog() {
      if (this.loading || !this.nextPage) return;
      this.loading = true;
      const status = this.querySelector('[data-hr-load-status]');
      const retry = this.querySelector('[data-hr-retry]');
      const more = this.querySelector('[data-hr-more]');
      if (retry) retry.hidden = true;
      if (more) more.hidden = true;
      status.textContent = this.cfg.loadingCatalog;
      this.grid.hidden = true;
      this.grid.setAttribute('aria-busy','true');
      const visited = new Set();
      const known = new Set([...this.grid.querySelectorAll('[data-hr-card]')].map(el => el.dataset.productId));
      try {
        while (this.nextPage) {
          const url = new URL(this.nextPage, location.origin);
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('pagination');
          visited.add(url.href);
          url.searchParams.set('section_id',this.dataset.sectionId);
          const response = await fetch(url, {signal:this.controller.signal,credentials:'same-origin'});
          if (!response.ok) throw new Error('catalog');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const section = doc.querySelector('homedics-renueva');
          if (!section?.querySelector('[data-hr-grid]')) throw new Error('section');
          section.querySelectorAll('[data-hr-card]').forEach(card => {
            if (!known.has(card.dataset.productId)) {known.add(card.dataset.productId);this.grid.appendChild(card);}
          });
          this.nextPage = section.querySelector('[data-hr-next]')?.getAttribute('href') || '';
        }
        status.textContent = '';
        this.grid.hidden = false;
        this.displayCards();
      } catch (error) {
        if (error.name === 'AbortError') return;
        status.textContent = this.cfg.catalogError;
        if (retry) retry.hidden = false;
        // Keep incomplete results hidden: never claim a partial catalog is globally sorted.
      } finally {
        this.loading = false;
        this.grid.removeAttribute('aria-busy');
      }
    }
    variant(event) {
      const select = event.target.closest('[data-hr-variant]');
      if (!select) return;
      const card = select.closest('[data-hr-card]'), option = select.selectedOptions[0];
      card.dataset.price = option.dataset.price;
      card.querySelector('[data-hr-price]').textContent = option.dataset.money;
      const compare = card.querySelector('[data-hr-compare]');
      compare.textContent = option.dataset.compareMoney;
      compare.hidden = Number(option.dataset.compare) <= Number(option.dataset.price);
      const badge = card.querySelector('[data-hr-badge]');
      badge.hidden = compare.hidden;
      badge.textContent = option.dataset.discount;
      const available = option.dataset.available === 'true';
      const button = card.querySelector('[type="submit"]');
      if (button) {button.disabled = !available;button.textContent = available ? this.cfg.add : this.cfg.soldOut;}
      card.querySelector('[data-hr-product-status]').textContent = '';
      if (option.dataset.image) {
        const img = card.querySelector('[data-hr-product-image]');
        if (img) {img.src = option.dataset.image;img.removeAttribute('srcset');}
      }
      this.displayCards();
    }
    async click(event) {
      if (event.target.closest('[data-hr-more]')) {this.visibleCount += this.pageSize;this.displayCards();}
      if (event.target.closest('[data-hr-retry]')) await this.loadCatalog();
      const copy = event.target.closest('[data-hr-copy]');
      if (copy && !copy.disabled) {
        const panel = copy.closest('[data-hr-coupon-panel]');
        const status = panel.querySelector('[data-hr-copy-status]');
        try {await navigator.clipboard.writeText(panel.querySelector('code').textContent.trim());status.textContent = this.cfg.copied;}
        catch (_) {status.textContent = this.cfg.copyManual;}
      }
    }
    async submit(event) {
      const form = event.target.closest('[data-hr-form]');
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      const button = form.querySelector('[type="submit"]');
      if (!button || button.disabled || form.dataset.busy) return;
      form.dataset.busy = 'true';
      button.disabled = true;
      button.textContent = this.cfg.adding;
      const status = form.querySelector('[data-hr-product-status]');
      status.textContent = '';
      const formData = new FormData(form);
      const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      let sectionIds = [];
      try {
        if (drawer?.getSectionsToRender) sectionIds = [...new Set(drawer.getSectionsToRender().map(section => section.id))].slice(0,5);
        else if (document.getElementById('cart-icon-bubble')) sectionIds = ['cart-icon-bubble'];
        if (drawer?.setActiveElement) drawer.setActiveElement(button);
      } catch (_) {sectionIds = [];}
      if (sectionIds.length) {
        formData.set('sections',sectionIds.join(','));
        formData.set('sections_url',location.pathname);
      }
      try {
        const response = await fetch(this.cfg.cartAdd, {method:'POST',credentials:'same-origin',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        let data;
        try {data = await response.json();} catch (_) {throw new Error(this.cfg.uncertain);}
        if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.cfg.error);
        status.textContent = this.cfg.added;
        const feedback = this.querySelector('[data-hr-cart-feedback]');
        feedback.hidden = false;
        feedback.querySelector('p').textContent = this.cfg.added;
        // A successful add must never be retried because a theme drawer failed to render.
        try {
          const complete = sectionIds.length && sectionIds.every(id => typeof data.sections?.[id] === 'string');
          if (complete && drawer?.renderContents) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
          } else if (typeof data.sections?.['cart-icon-bubble'] === 'string') {
            const parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'],'text/html');
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) bubble.innerHTML = (parsed.querySelector('.shopify-section') || parsed.body).innerHTML;
          }
        } catch (_) { /* Visible success message and native cart link remain available. */ }
        document.dispatchEvent(new CustomEvent('afterCartChanged',{detail:{productVariantId:formData.get('id'),source:'homedics-renueva',cartData:data}}));
        this.dispatchEvent(new CustomEvent('homedics:cart-added',{bubbles:true,detail:{variantId:formData.get('id'),cartData:data}}));
      } catch (error) {
        status.textContent = error instanceof TypeError ? this.cfg.uncertain : error.message || this.cfg.error;
      } finally {
        delete form.dataset.busy;
        const option = form.querySelector('select')?.selectedOptions[0];
        button.disabled = option ? option.dataset.available !== 'true' : false;
        button.textContent = button.disabled ? this.cfg.soldOut : this.cfg.add;
      }
    }
  });
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
